export default __webpack_public_path__ + "static/media/storm.2bea7ba6.png";